module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("I have written this book for preachers, seminary students, and Bible teachers. My primary aim is to encourage and help busy preachers and teachers to proclaim the Genesis narratives. This book will enable them to uncover rather quickly the important building-blocks for producing sermons and lessons on Genesis: to detect the story line of each narrative (the plot); to formulate the heart of the message for Israel (the theme); to discover the response sought from Israel and by analogy from the church today (the goal); to uncover various ways to link each narrative to Jesus Christ in the New Testament; and to obtain relevant biblical exposition of key verses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This book, as a companion to my "), _c('em', [_vm._v("Preaching Christ from the Old Testament")]), _vm._v(", is further intended to demonstrate and reinforce the redemptive-historical Christocentric method. While Christocentric preaching is always theocentric, it moves beyond the theocentric focus to the fullness of God’s self-revelation in Jesus Christ. As the apostle John explains, “No one has ever seen God. It is God the only Son, who is close to the Father’s heart, who has made him known” (John 1:18).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("Readers will notice that I follow the same basic pattern for each narrative. This pattern is based on the ten steps from text to sermon I developed for first-year seminary students (see ")]), _c('span', {
    attrs: {
      "href": "#/034_Appendix01#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn_1",
      "id": "fn-1"
    }
  }, [_vm._v("1")])]), _vm._v(" The resulting repetition in each chapter is intended to inculcate a basic hermeneutical-homiletical approach to the biblical text. First we search for the narrative unit and check its context. Next we note important literary features and especially the plot line, which is important not only for understanding the narrative but also for preaching the sermon in a narrative form. After theocentric interpretation, we seek to formulate "), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("the textual theme and goal. With the theme in mind, we can brainstorm for various roads that lead from this particular narrative to Jesus Christ in the New Testament. Having seen the Old Testament message in the context of the New Testament, we are ready to extend the textual theme and goal to the sermon theme and goal. I conclude each chapter with a section on “sermon exposition,” which can be used not only for better understanding the narrative but also for gathering insights to incorporate into one’s sermon. This section seeks to provide a model for the sermon by using oral style as much as possible, giving the verse reference "), _c('em', [_vm._v("before")]), _vm._v(" the quote so that the congregation can read along (comprehension is much better when the congregation not only hears but sees the words), and keeping the narrative moving (most quotations, complex arguments, and technical details are relegated to footnotes). I have indicated where in the exposition and how I might make the move(s) to Christ in the New Testament. These moves are intended only as suggestions, for while writing the actual sermon one may discover better ways and places to move to Christ. Finally, related to the goal, I make brief suggestions for application. In actual sermons, these “applications” will need to be fleshed out with illustrations and concrete suggestions appropriate to the situation of the congregation being addressed.")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("In the past, I have had several essays on Genesis passages published."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn_2",
      "id": "fn-2"
    }
  }, [_vm._v("2")]), _vm._v(" For this book I have revised these articles and expanded them considerably. In "), _c('span', {
    attrs: {
      "href": "#/035_Appendix02#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2")]), _vm._v(" I have reproduced the expository sermon model I developed for first-year students at Calvin Theological Seminary. This model aims for sermons that are biblical, relevant, and well organized. I have also included three of my own sermons on Genesis narratives to further demonstrate the practical outcome of following this model in sermon construction (see "), _c('span', {
    attrs: {
      "href": "#/036_Appendix03#bm-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendixes 3 to 5")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Unless otherwise noted, the Bible version quoted is the NRSV. In these quotations I have occasionally emphasized words by italicizing them. Without notation, every reader will understand that these are "), _c('em', [_vm._v("my")]), _vm._v(" emphases since they are neither in the original Hebrew nor in the NRSV.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Hebrew transliterations throughout have been regularized using the pattern found in Willem A. VanGemeren, gen. ed., "), _c('em', [_vm._v("New International Dictionary of Old Testament Theology and Exegesis")]), _vm._v(", V, xxi (see "), _c('a', {
    attrs: {
      "href": "#/009_Transliterations#page_xvii"
    }
  }, [_vm._v("p. xvii")]), _vm._v(" below).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("References in the footnotes have been kept to a minimum: full references "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("can be found in the Bibliography. When a book or article is not included in the Select Bibliography, complete information is found in the footnote. The Table of Contents has been designed to function as a Subject Index for the major subjects treated in ")]), _c('a', {
    attrs: {
      "href": "#/010_Chapter01#ch-1"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" and as a Text Index for the major texts treated in "), _c('span', {
    attrs: {
      "href": "#/011_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 2")]), _vm._v(" to "), _c('span', {
    attrs: {
      "href": "#/033_Chapter24#ch-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(". More detailed Subject and Scripture Indexes are found on pp. 510–18.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I send this book into the world with the hope and prayer that it may stimulate many preachers to preach the Genesis narratives as it spawns ideas, in text and footnotes, for developing sermons that will build up God’s people with the biblical vision of paradise restored, the coming kingdom of God.")]), _vm._v(" "), _c('p', {
    staticClass: "para-sign"
  }, [_c('em', [_vm._v("Grand Rapids, Michigan")])]), _vm._v(" "), _c('p', {
    staticClass: "para-r"
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IDNEY")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REIDANUS")])]), _vm._v(" "), _c('p', {
    staticClass: "image-fn"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-1",
      "id": "fn_1"
    }
  }, [_vm._v("1")]), _vm._v(". I have explained these ten steps and applied them to Genesis 22 in my "), _c('em', [_vm._v("Preaching Christ from the Old Testament")]), _vm._v(", 279–318.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn-2",
      "id": "fn_2"
    }
  }, [_vm._v("2")]), _vm._v(". The publication started with Genesis 22:1–19 in my "), _c('em', [_vm._v("Preaching Christ from the Old Testament")]), _vm._v(", 292–318. Next Roger Van Harn invited me to submit some essays for "), _c('em', [_vm._v("The Lectionary Commentary")]), _vm._v(" he was editing. I wrote on Genesis 6:9–8:22; 24:1–67; 28:10–22; 29:15–35; and 37:1–36—respectively, pp. 11–16; 43–48; 52–56; 56–60; and 64–68 of Vol. 1. Then Dallas Theological Seminary invited me to give some special lectures on preaching Christ from the Old Testament. Here I tried out the format of expository essays which, with some changes, I am using in this book. These lectures on Genesis 1:1–2:3; 2:4–3:24; and 4:1–26 were subsequently published in "), _c('em', [_vm._v("BSac")]), _vm._v(" 161 (2004)—respectively, pp. 131–41; 259–73; and 387–97.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb5394dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Preface.vue
// module id = 72
// module chunks = 0